import { BaseComponent } from 'src/app/framework/components/base.component';
import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ZipCodes } from '../../../features-common/constants/ZipCodes';
import Swal from 'sweetalert2';
import { ProvidersService } from '../providers.service';
import { Location } from '@angular/common'
//import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-provider',
  templateUrl: './edit-provider.component.html',
  styleUrls: ['./edit-provider.component.scss'],
})
export class EditProviderComponent extends BaseComponent implements OnInit, OnDestroy {
  providerDetails: any;
  updateProviderForm: FormGroup;
  public phone: Array<string | RegExp>;
  usStateZips;
  providerId: number;
  selectedstatus;
  selectedstate;


  constructor(private cdref: ChangeDetectorRef, private fb: FormBuilder, public dialog: MatDialog, private router: Router, private providersService: ProvidersService, private location: Location, private activeRoute: ActivatedRoute) {
    super();
    this.phone = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }

  ngOnInit(): void {
    super.ngOnInit()
    this.usStateZips = ZipCodes.USAStatesShort;
    //this.updateProviderForm = new FormGroup(){}
    this.providerId = this.activeRoute.snapshot.params.id;
    this.updateProviderForm = new FormGroup({
      providerName: new FormControl(''),
      contactName: new FormControl(''),
      mobileNumber: new FormControl(''),
      email: new FormControl(''),
      providerStatus: new FormControl(''),
      address1: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      zip: new FormControl('')
    })

    if (this.providerId && this.providerId) {
     
      this.providersService.getProvider(this.providerId).subscribe(
        res => {
          let data: any = res;
          this.providerDetails = data.data;
         
          this.selectedstatus = this.providerDetails.providerStatus;
          this.selectedstate = this.providerDetails.providerState;
          this.updateProviderForm.get('providerName').setValue(this.providerDetails.providerName),
            this.updateProviderForm.get('contactName').setValue(this.providerDetails.contactName),
            this.updateProviderForm.get('mobileNumber').setValue(this.providerDetails.mobileNumber),
            this.updateProviderForm.get('email').setValue(this.providerDetails.email),
            this.updateProviderForm.get('providerStatus').setValue(this.providerDetails.providerStatus),
            this.updateProviderForm.get('address1').setValue(this.providerDetails.address1),
            this.updateProviderForm.get('city').setValue(this.providerDetails.city),
            this.updateProviderForm.get('state').setValue(this.providerDetails.state),
            this.updateProviderForm.get('zip').setValue(this.providerDetails.zip)

        })
    }


  }
  compareStateObj(f1: any, f2: any) { 
    return f1 && f2 && f1.state === f2.state;
  }
  get f() {
    return this.updateProviderForm.controls;
  }

  onProductDetails() {
    if (!this.updateProviderForm.valid) {
      return
    }
    
    let formData: Params = {
      providerId: this.providerId,
      providerName: this.updateProviderForm.get('providerName').value,
      contactName: this.updateProviderForm.get('contactName').value,
      mobileNumber: this.updateProviderForm.get('mobileNumber').value,
      email: this.updateProviderForm.get('email').value,
      status: this.updateProviderForm.get('providerStatus').value,
      address1: this.updateProviderForm.get('address1').value,
      city: this.updateProviderForm.get('city').value,
      state: this.updateProviderForm.get('state').value,
      zip: this.updateProviderForm.get('zip').value.toString()
    };

    

    this.providersService.updateProvider(formData).subscribe(
      res => {
        if (res && res) {
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
            this.router.navigate(['features/providers/allproviders'])
            this.toastrService.success('Provider updated successfully', 'Success', {
              timeOut: 3000,
            });        
        } else if (res && res.httpcode == 400) {
            Swal.fire(
              {
                title: 'Failure',
                text: 'Update provider failed',
                icon: 'error',
                timer: 2000
              }
            )
          }else{
            Swal.fire(
              {
                title: res.responseStatus,
                text: res.userMessage,
                icon: 'error',
                timer: 2000,
                willClose: () => {
    
                }
              })  
          }  
        }

      }
    );
  }

  onCancel() {
    this.router.navigate(['features/providers/allproviders']);
    //this.updateProviderForm.reset()
    //this.location.back()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }
  charMask(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9| ]+$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }

  checkSubmitDisplayed() {
    return !(this.updateProviderForm.valid && !this.updateProviderForm.pristine); 
  }
}